/** Wire metadata every Segment source event carries. */
export const SEGMENT_OUT_ANALYTICS_META = {
  'Integration Name': 'Segment',
  'Integration Category': 'Data management',
  'Integration Sub-Category': 'Source',
} as const;

/**
 * `Enabled` the first time the connector is switched on, `Re-Enabled` after that.
 *
 * Ember read this from `isNewIntegration`, which is a statement about the events
 * the record was loaded with rather than about the toggle.
 */
export function enableStartedProperties(isFirstEnable: boolean) {
  return {
    ...SEGMENT_OUT_ANALYTICS_META,
    'Integration Enabled or Re-Enabled': isFirstEnable ? 'Enabled' : 'Re-Enabled',
  };
}

/** `Disabled` for the toggle, `Deleted` when the connector is removed entirely. */
export function disableStartedProperties(action: 'Disabled' | 'Deleted') {
  return {
    ...SEGMENT_OUT_ANALYTICS_META,
    'Integration Disabled or Deleted': action,
  };
}
